export default [
  { label: 'Evet', id: 1 },
  { label: 'Hayır', id: 0 },
];
